import React from 'react';
import { Link } from 'react-router-dom';
import RedesignShell from '../components/redesign/RedesignShell.jsx';
import { NavBar, Footer } from '../components/redesign/shared.jsx';
import SEO from '../components/SEO.jsx';

function NotFoundInner({ onNav }) {
  return (
    <div className="pageA">
      <SEO
        title="Page Not Found | Aakeeo"
        description="The page you're looking for doesn't exist. Explore our SuiteCRM services, use cases, and resources."
      />
      <NavBar page="home" onNav={onNav} />

      <main>

      <section className="notFoundA">
        <span className="eyebrowA">404</span>
        <h1>
          This page doesn&apos;t <em>exist</em>.
        </h1>
        <p>
          The URL may have changed, or the link you followed is out of date. Here&apos;s where you probably meant to go.
        </p>
        <div className="notFoundA-cta">
          <Link to="/" className="btnA-primary">Home</Link>
          <Link to="/services" className="btnA-ghost">Solutions →</Link>
          <Link to="/opensource" className="btnA-ghost">Open Source →</Link>
          <Link to="/resources" className="btnA-ghost">Resources →</Link>
          <Link to="/contact" className="btnA-ghost">Contact →</Link>
        </div>
      </section>

      </main>

      <Footer onNav={onNav} />
    </div>
  );
}

export default function NotFound() {
  return (
    <RedesignShell>
      {({ onNav }) => <NotFoundInner onNav={onNav} />}
    </RedesignShell>
  );
}
